import { placeholders } from './contentful-placeholders';

type Placeholders = 'preisersparnis' | 'sonnenkilometer' | 'co2einsparung' | 'autarkiegrad';

type ReplaceContentfulPlaceholderParams = {
  content: string;
  values?: PvWizardResultSectionOffer['values'];
};

export const replaceContentfulPlaceholder = ({
  content,
  values
}: ReplaceContentfulPlaceholderParams) => {
  const replaceType = placeholders.find(placeholder => content.includes(placeholder));

  if (!replaceType || !values) {
    return content;
  }

  const replaceValue = values[replaceType.toLowerCase() as Placeholders];
  const formattedValue = replaceValue.toLocaleString('de-DE');

  return content.replace(`{${replaceType}}`, formattedValue);
};
